import styled from '@emotion/styled';

export const IconWrapper = styled.div`
	.icon {
		border-radius: var(--small-border-radius);
		width: 5rem;
		height: 5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		background: var(--statistic-card-bg-color);
		color: var(--statistic-card-text-color);
	}
`;

export const HeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 2rem;
	margin-bottom: 2rem;
`;

export const DetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3rem;
`;
